import actionTypes from './actionTypes';

const initialState = {
    entities: {},
    queries: {},
    list: {}
};

const reducer = (state = initialState, action) => {
    const { type } = action;
    switch (type) {
        case actionTypes.REQUEST_START: {
            const { queryKey, url } = action;
            state.queries[queryKey] = {
                isPending: true,
                isFinished: false,
                url: url
            };
            return state;
        }
        case actionTypes.REQUEST_SUCCESS: {
            const { entities, list, queryKey, status } = action;
            return {
                list,
                entities,
                queries: {
                    ...state.queries,
                    [queryKey]: {
                        url: state.queries[queryKey].url,
                        isFinished: true,
                        isPending: false,
                        status
                    }
                }
            };
        }
        case actionTypes.REQUEST_FAILURE: {
            const { queryKey, status } = action;
            return {
                ...state,
                queries: {
                    ...state.queries,
                    [queryKey]: {
                        url: state.queries[queryKey].url,
                        isFinished: true,
                        isPending: false,
                        status
                    }
                }
            };
        }
        default: {
            return state;
        }
    }
};

export default reducer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/requery/reducer.js
 **/